module.exports = __webpack_public_path__ + "static/media/clap.81946c28.wav";